import React, { useState, useEffect } from "react";
import EditPill from "./EditPill";
import "./DefineMedia.scss";
import ReactPlayer from "react-player";

import FileUploadBox from "./FileUploadBox";
import Loading from "../Loading";

export default function DefineMedia({ isAdmin, isBulkUpload, style, toggleModal, errorStyles, storageUrl, pageType, error, ...props }) {
  const [content, set_content] = useState(props.pageType === "gallery" ? 1 : "thumbnail");
  const [clickUpload, set_clickUpload] = useState(false);
  const [media, set_media] = useState(props.media != undefined ? props.media : {});
  const [wrongFormat, set_wrongFormat] = useState(false);
  let [loading,setLoading]=useState(true)

  useEffect(() => {
    set_media(props.media);
    setLoading(false)
  }, [props.media]);

  useEffect(() => {
    if (error) {
      set_wrongFormat(error);
    }
  }, [error]);

  function addUrlToDeleteArray(url) {
    props.addToDeleteUrl(pageType, url);
    props.onMediaChange(false);
  }

  const onChange = (media) => {
    props.onMediaChange(media);
    set_wrongFormat(false);
  };

  const inputClicked = (bool) => {
    set_clickUpload(bool);
    set_wrongFormat(false);
  };
console.log("media",media)
  return (
    <div className="c-media-edit-container">
      <>
        {media ? (
          <>
            {pageType === "video" ? (
              <div className="c-detailheader-img c-detailheader-video" onClick={() => toggleModal()}>
                {!loading?<ReactPlayer url={media} loop={true} volume={0} muted={true} playing={true} width={150} style={{ position: "relative", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />:<span style={{display: "block",textAlign: "center",marginTop: "60px"}} >Loading...</span>}
              </div>
            ) : (
              <div style={{ backgroundImage: `url("${media}")` }} className="c-detailheader-img" />
            )}
          </>
        ) : (
          <FileUploadBox initiated={() => set_wrongFormat(false)} style={style} content="cover" onChange={onChange} pageType={pageType} clicked={clickUpload} inputClicked={inputClicked} deleteUrlArray={props.deleteUrlArray} storageUrl={storageUrl} set_wrongFormat={set_wrongFormat} />
        )}
      </>

      {media && isAdmin && (
        <div style={{position: "relative"}}>
          <EditPill isMinusIcon={true} onClick={() => addUrlToDeleteArray(media)} />
        </div>
      )}
      {wrongFormat && (
        <p style={errorStyles ? errorStyles : {}} className="c-error-message">
          {wrongFormat}
        </p>
      )}
    </div>
  );
}
